import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';
import s from './Navigation.css';
import Link from '../Link';
import { logout } from '../../actions';
import {
  PACKAGE_MULTI,
  ROLE_SUPER_ADMIN,
  ROLE_EXECUTIVE_ADMIN
} from '../../constants';

const mapStateToProps = state => ({
  username: state.auth.user.username,
  firstname: state.auth.user.firstName,
  roleId: state.auth.user.role_id,
  userpackage: state.auth.package
});

const mapDispatchToProps = dispatch => ({
  onLogoutClick() {
    dispatch(logout());
    window.toastr.info('You have been successfully logged out!');
  }
});

class Navigation extends React.Component {
  static propTypes = {
    username: PropTypes.string,
    firstname: PropTypes.string,
    roleId: PropTypes.number,
    userpackage: PropTypes.shape({ id: PropTypes.number }),
    onLogoutClick: PropTypes.func.isRequired
  };

  static defaultProps = {
    username: '',
    firstname: '',
    roleId: 0,
    userpackage: {}
  };

  simplify(name) {
    if(name.length > 10) {
      return name.substr(0, 10).concat('...');
    }
    return name;
  }

  render() {
    const {
      username,
      firstname,
      roleId,
      onLogoutClick,
      userpackage
    } = this.props;

    return (
      <ul
        className={cx('nav', 'navbar-nav', 'navbar-right', s.navbar, s.default)}
      >
        <li>
          <Link to="/app">Bitaa App</Link>
        </li>
        <li>
          <Link to="/about">Why Bitaa?</Link>
        </li>
        <li>
          <Link to="/howto">How does it work?</Link>
        </li>
        <li>
          <Link to="/videos">Videos</Link>
        </li>
        {(roleId === ROLE_SUPER_ADMIN || roleId === ROLE_EXECUTIVE_ADMIN) &&
          <li className="dropdown">
            <Link
              to="#"
              subPaths="/activity,/project"
              styleName={cx('dropdown-toggle', s.toggle)}
              data-toggle="dropdown"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Settings <span className="caret" />
            </Link>
            <ul className={cx('dropdown-menu', s.menu)}>
              <li>
                <Link to="/activity">Short-Term Activity</Link>
              </li>
              <li>
                <Link to="/project">Project</Link>
              </li>
            </ul>
          </li>
        }
        {username &&
          <li className="dropdown" title={firstname || username}>
            <Link
              to="#"
              subPaths="/profile"
              styleName={'dropdown-toggle'}
              data-toggle="dropdown"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {this.simplify(firstname) || this.simplify(username)} <span className="caret" />
            </Link>
            <ul className={cx('dropdown-menu', s.menu)}>
              <li>
                <Link to="/profile">
                  {userpackage && userpackage.id === PACKAGE_MULTI
                    ? 'Dashboard'
                    : 'Profile'}
                </Link>
              </li>
              <li>
                <Link to="/home" onClick={onLogoutClick}>
                  Logout
                </Link>
              </li>
            </ul>
          </li>}
        {!username &&
          <li>
            <Link to="/login">Log In</Link>
          </li>}
      </ul>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(s)(Navigation)
);



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js